import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';



@Injectable()
export class RequestCacheService {

  private cache = new Map<string, [Date, HttpResponse<any>]>();

  get(req: HttpRequest<any>): HttpResponse<any> {

    const encodedParams = req.params
      .keys()
      .sort()
      .map(k => `${k}=${req.params.get(k)}`)
      .join('&');
    const key = req.url + '?' + encodedParams;
    const tuple = this.cache.get(key);
    if (!tuple) {
      return null as any;
    }

    const expires = tuple[0];
    const httpResponse = tuple[1];

    // Don't observe expired keys
    const now = new Date();
    if (expires && expires.getTime() < now.getTime()) {
      this.cache.delete(key);
      return null as any;
    }
    return httpResponse;
  }

  set(req: HttpRequest<any>, value: any, ttl?: number) {

    const encodedParams = req.params
      .keys()
      .sort()
      .map(k => `${k}=${req.params.get(k)}`)
      .join('&');
    const key = req.url + '?' + encodedParams;

    if (ttl) {
      const expires = new Date();
      expires.setSeconds(expires.getSeconds() + ttl);
      this.cache.set(key, [expires, value]);
    } else {
      this.cache.set(key, [null as any, value]);
    }

  }
}